import React from 'react';
import Header from '../components/Header'
import Meta from '../components/Meta'

const Home = () => {
  // page content
  const pageTitle = 'Project Sigma'
  const pageDescription = 'Welcome to Project Sigma'

  return (
    <div>
      <Meta title={pageTitle}/>
      <Header head={pageTitle} description={pageDescription} />
    <div>
    <p> Project Sigma is a website that presents solutions, interactively, for <a href="https://projecteuler.net/archives" target="_blank" className="reflink">Project Euler Problems.</a> I am working this project with the intent of improving my skills in mathematics, algorithm and data structure. It is a life-long project which I intend to keep updating till I finish solving all the problems from the Project Euler site.
    <br />
    <br />
    I built Project Sigma using JavaScript, React, Bootstrap and Sass and I update with solutions as I solve the problems in JavaScript, Java, and Python at my leisure. I have also featured interesting visuals and logic</p>
    <p>
      If you have any correction or suggestion, you can reach out to me on <a href="https://twitter.com/engrcollins14" target="_blank">Twitter.</a>
      <br />
      If you are fascinated by this life-long project I am building and you would like to buy me a coffee, kindly do that <a href="https://twitter.com/engrcollins14" target="_blank">here.</a>
      <br />
      <br />
      You can visit <a href="https://collinsakinbami.netlify.app" target="_blank">my portfolio</a> to check out my other projects.
    </p>
    </div>
    </div>
  )
}

export default Home